import React, { useEffect } from "react";
import styled from "styled-components";
import ProfileDownloadIcon from './ProfileDownloadIcon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 16px;
  padding-top: 36px;
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */
    letter-spacing: 0.1px;
    /* Colors / Text / Main */
    color: #FFFFFF;
    margin-top: 24px;
    margin-bottom: 6px;
`;

const Button = styled.a`
    /* background: rgba(255, 255, 255, 0.2); */
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    padding: 16px 10px;
    border-radius: 8px;
    width: 92%;
    text-align: center;
    color: #fff;

`;

const SubTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 140%;
    /* or 21px */

    text-align: center;

    /* Colors/Text / Subtitle */

    color: #7A7F9E;
    margin-bottom: 36px;
`;

export default function DownloadBottomSheet(props) {
  return (    
    <Container>
        <ProfileDownloadIcon img={props.img}></ProfileDownloadIcon>
        <Title>Looks like you're enjoying!</Title>
        <SubTitle>Want to check out the full app,<br></br>perhaps?</SubTitle>
        <Button 
          href={props.href ? props.href : "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"}
          onClick={() => {
            window.analytics.track('download_button_pressed', {
              from: 'bottom-sheet',
              type: 'mobile'
            }) 
          }}
          >
            Download Android app now
        </Button>
    </Container>      
  );
}
